import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IBudgetState } from './store/budget.state';
import { setBudgetAction } from './store/budget.actions';
import { getBudgetSelectors } from './store/budget.selectors';
import { IBudgetData } from 'src/app/modules/interfaces/budget.interface';
import { BudgetsService } from 'src/app/services/budget.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.scss'],
})
export class BudgetComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;
  budgetData: IBudgetData = {
    id: 0,
    has_budget: null,
    montly_cost: null,
    montly_revenue: null,
    gross_annual_revenue: null,
  };

  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataBudgetState$: Observable<IBudgetState>;
  dataBudgetState: IBudgetState;

  ngOnInit(): void {
    this.getState();
    this.loadBudgetData();
  }

  constructor(private store: Store, private budgetsService: BudgetsService) {
    this.formsId = Number(getCookie('formsId'));
  }

  loadBudgetData(): void {
    this.isLoading = true
    this.budgetsService.getBudgetsData(this.formsId).subscribe((response) => {
      if (response) {
        this.budgetData = {
          id: response.id,
          has_budget: response.has_budget,
          montly_cost: response.montly_cost || null,
          montly_revenue: response.montly_revenue || null,
          gross_annual_revenue: response.gross_annual_revenue || null,
        };

        this.saveState();
      }
    });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: Partial<IBudgetData> = {
      has_budget: this.budgetData.has_budget,
      montly_cost: this.budgetData.montly_cost,
      montly_revenue: this.budgetData.montly_revenue,
      gross_annual_revenue: this.budgetData.gross_annual_revenue,
    };

    this.budgetsService
      .updateBudgetsData(this.formsId, this.budgetData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState();
          this.formSaved.emit();
        },
        error: () => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
        },
      });
  }

  saveState(): void {
    this.dataBudgetState = {
      check: true,
      idealBudget: Boolean(this.budgetData.has_budget),
      monthlyCost: Number(this.budgetData.montly_cost),
      monthlyIncome: Number(this.budgetData.montly_revenue),
      annualRecipe: Number(this.budgetData.gross_annual_revenue),
    };
    this.setState(this.dataBudgetState);
  }

  updateAmount(event: number, field: keyof IBudgetData): void {
    this.budgetData = {
      ...this.budgetData,
      [field]: event,
    };
    this.onFieldChange();
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  startTrial(): void {
    this.setState(this.dataBudgetState);
  }

  setState(data: IBudgetState) {
    this.store.dispatch(setBudgetAction(data));
    this.isLoading = false
  }

  getState() {
    this.dataBudgetState$ = this.store.select(getBudgetSelectors);

    this.dataBudgetState$.subscribe((value) => {
      this.dataBudgetState = {
        ...(this.dataBudgetState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataBudgetState.check = false;
    if (this.dataBudgetState.idealBudget != undefined) {
      this.dataBudgetState.check = true;
    }
    this.setState(this.dataBudgetState);
  }
}
